// This app's own hostnames, mapped to the consent dashboard that serves it on its own
// origin (and handles sign-in for it).
const LEGACY_TO_CONSENT_DASHBOARD_HOSTNAME: Record<string, string> = {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'dashboard.sentinelinsights.com': 'app.sentinelinsights.com',
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'dashboard.dev.sentinelinsights.com': 'dev.app.sentinelinsights.com',
};

/**
 * The same page on the consent dashboard when `url` is on one of this app's own
 * hostnames; otherwise `url` unchanged.
 */
export function toConsentDashboardUrl(url: string): string {
  const parsed = new URL(url);
  const consentDashboardHostname = LEGACY_TO_CONSENT_DASHBOARD_HOSTNAME[parsed.hostname];
  if (!consentDashboardHostname) {
    return url;
  }
  parsed.hostname = consentDashboardHostname;
  return parsed.toString();
}
